import Vue from 'vue';

function addSrcSet(el) {
  const { src } = el;

  if (!src) {
    return;
  }
  if (src.search('imgix.net') === -1) {
    // console.log('img', el, 'not an imgix.net');
    return;
  }
  const dpr = src.includes('?') ? '&dpr' : '?dpr';
  el.srcset = `${src}${dpr}=1 1x,${src}${dpr}=2 2x,${src}${dpr}=3 3x`;
}

Vue.directive('srcset', {
  bind: addSrcSet,
  update: addSrcSet,
});
